import { noop } from 'lodash';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { AVATAR_SIZES, AvatarButton, Popover, Tooltip } from '@didaskill/ui/design-system';

import {
  ProfilePopoverContent,
  type ProfilePopoverContentProps,
} from './content/ProfilePopoverContent';
import messages from './ProfilePopover.messages';

export type ProfilePopoverProps = ProfilePopoverContentProps & {
  size?: AVATAR_SIZES;
  isOpen?: boolean;
  onShow?: () => void;
  onHide?: () => void;
};

export const ProfilePopoverBase = ({
  user,
  subtitle,
  onClickLogout = noop,
  size = AVATAR_SIZES.MEDIUM,
  isOpen = false,
  onShow = noop,
  onHide = noop,
  children,
}: ProfilePopoverProps) => {
  const handleToggle = () => {
    if (isOpen) {
      onHide();
    } else {
      onShow();
    }
  };

  return (
    <Popover
      interactive
      placement="bottom-end"
      visible={isOpen}
      onShow={onShow}
      onHide={onHide}
      onClickOutside={onHide}
      content={
        <ProfilePopoverContent user={user} subtitle={subtitle} onClickLogout={onClickLogout}>
          {children}
        </ProfilePopoverContent>
      }
    >
      <Tooltip content={<FormattedMessage {...messages.TOOLTIP} />}>
        <div id="profile-avatar-button">
          <AvatarButton onClick={handleToggle} user={user} isShadowed={isOpen} size={size} />
        </div>
      </Tooltip>
    </Popover>
  );
};

ProfilePopoverBase.displayName = 'ProfilePopover';

export const ProfilePopover = memo(ProfilePopoverBase);
